import { StripeCardTypes } from '@givebacks/api/core';

import { TokenExCardTranslations } from '../../../hooks/TokenEx/utils';

type StripeCardForm = {
  token: string | null;
  card_type: '' | StripeCardTypes;
  shouldSaveCard: boolean;
};

const STRIPE_TO_TOKENEX_CARD_TYPE_MAP: Record<StripeCardTypes, TokenExCardTranslations> = {
  Visa: TokenExCardTranslations.visa,
  MasterCard: TokenExCardTranslations.masterCard,
  'American Express': TokenExCardTranslations.americanExpress,
  Discover: TokenExCardTranslations.discover,
  'Diners Club': TokenExCardTranslations.diners,
};

export { STRIPE_TO_TOKENEX_CARD_TYPE_MAP };
export type { StripeCardForm };
